import { IconButton, Tooltip } from "@mui/material";
import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/styles";
import useLocales from "../../hooks/useLocales";

interface IListShowButton {
  data: any;
  path?: string;
}

const ShowButton = styled(IconButton)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  color: "#853EF8",
  "&:hover": {
    backgroundColor: "transparent",
    borderColor: "#0062cc",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

const ListShowButton: FC<IListShowButton> = ({ data, path }) => {
  const { translate } = useLocales();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  function handleClick() {
    const customPath = path
      ? `${pathname}/${data.id}/${path}`
      : `${pathname}/${data.id}`;
    return navigate(customPath);
  }

  return (
    <Tooltip title={translate("actions.show")}>
      <ShowButton onClick={handleClick}>
        <i className="icon-remove_red_eye"></i>
      </ShowButton>
    </Tooltip>
  );
};

export default ListShowButton;
